import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

import moment from 'moment'
import { connect } from 'react-redux';
import * as RemittanceLogCheck from './Saga/RemittanceLogCheck';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

const { CSVLink } = require('react-csv');
// import DatePicker from "react-datepicker";
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  so_ymd_list: any,
  get_owner_remittance_check_logs: any,
  remittancelogcheck_search_form: any,
  change_remittancelogcheck_search_form: any,
  change_search_diff: any,
  so_ymd_list_sum: number,
  owner_remittance_check_logs_sum: number,
  owner_remittance_check_logs: any,
  owner_remittance_check_logs_list: any,

  // search_form: any,
  // check_completed: any,
  // get_rent_contracts_check_list: any,
  // rent_contracts_check_list: any,
  // check_completed_cancel: any,

  // get_rent_contracts: any,
  // change_search_name: any,
  // change_search_contract_date_start: any,
  // change_search_contract_date_end: any,
  // search_contract_date_start: any,
  // search_contract_date_end: any,
  // change_search_tatemono_name: any,
  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string
}



interface State {
  reflesh: boolean
}


class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    // this.props.change_search_name("")
    this.state = {
      reflesh: false
    }
    // this.props.change_search_contract_date_end(null)
    // this.change_search_name = this.change_search_name.bind(this);

    // this.handleContractionDateChange = this.handleContractionDateChange.bind(this);
    // this.handleContractionDateChangeEnd = this.handleContractionDateChangeEnd.bind(this);

    this.handleChange = this.handleChange.bind(this);

    this.handle_change_search_diff = this.handle_change_search_diff.bind(this);

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }
  handleChange(e: any) {

    let remittancelogcheck_search_form = this.props.remittancelogcheck_search_form
    remittancelogcheck_search_form[e.target.name] = e.target.value

    this.props.change_remittancelogcheck_search_form(remittancelogcheck_search_form)

    this.setState({ reflesh: !this.state.reflesh })
  }

  // change_search_tatemono_name(e: any) {
  //   let search_form = this.props.search_form
  //   search_form.search_tatemono_name = e.target.value
  //   this.props.change_search_form(search_form)
  //   this.setState({ reflesh: !this.state.reflesh })
  // }
  // handleContractionDateChange(e: any) {
  //   let search_form = this.props.search_form
  //   search_form.search_contract_date_start = e
  //   this.props.change_search_form(search_form)
  //   this.setState({ reflesh: !this.state.reflesh })
  //   // this.props.change_search_contract_dat / e_start(e)

  // }
  // search(e: any) {
  //   this.props.get_owner_remittance_check_logs()
  //   // this.props.change_search_contract_date_end(e)
  // }

  handle_change_search_diff(e: any) {

    if (e.target.checked) {
      this.props.change_search_diff(true)

    } else {
      this.props.change_search_diff(false)
    }
  }

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div>

        <table>

          <tbody>

            <tr >

              <td >
                <TextField
                  name="search_name"
                  //   component="input"
                  // value={this.props.search_form.search_name}
                  type="text"
                  label="お客様名"
                  // onChange={this.change_search_name}
                  className="form-control"
                />

              </td>

              <td >
                <TextField
                  name="search_tatemono_name"
                  // value={this.props.search_form.search_tatemono_name}
                  type="text"
                  label="物件名"
                  // onChange={this.change_search_tatemono_name}
                  className="form-control"
                />

              </td>
              <td>





                {/* <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.all_selected(true)}
                  className="btn btn-sm btn-warning float-right"
                >全選択</button>

                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.all_selected(false)}
                  className="btn btn-sm btn-success float-right"
                >全解除</button> */}
              </td>
            </tr>
            <tr >

              <td colSpan={2}>

                <FormControl style={{ width: '150px', margin: 10 }} >
                  <InputLabel id="demo-simple-select-label">送金日</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="so_ymd"
                    // value={age}
                    onChange={this.handleChange}
                  >
                    {this.props.so_ymd_list.map(function (value: any) {
                      return <MenuItem value={value.so_ymd}>{moment(value.so_ymd).format("YYYY/MM/DD")}</MenuItem>
                    })}

                  </Select>
                </FormControl>
                {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="contractDataStart"
                    //    onChange={this.handleContractionDateChangeStart}
                    // value={this.props.search_contract_date_start}
                    // value={this.props.search_form.search_contract_date_start}
                    // onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
           ～
           <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "10px" }}
                    // value={this.props.search_form.search_contract_date_end}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="contractDataEnd"
                    // value={this.props.search_contract_date_end}
                    // //  value={this.props.estimateData.applicationDate}
                    // onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />
   : state.RemittanceLogCheck.so_ymd_list_sum,
    owner_remittance_check_logs_sum: state.RemittanceLogCheck.owner_remittance_check_logs_sum,
                </MuiPickersUtilsProvider> */}
                <span>　送金額:{this.props.so_ymd_list_sum.toLocaleString()}</span>
                <span>　印刷時:{this.props.owner_remittance_check_logs_sum.toLocaleString()}</span>
                <FormControlLabel
                  control={
                    <Checkbox
                      // checked={this.props.search_form.search_completed}
                      onChange={this.handle_change_search_diff}
                      name="search_diff"
                      color="primary"

                    />
                  }
                  label="差額のみ"
                  style={{ marginTop: "20px", marginLeft: "60px" }}
                />
                {this.props.owner_remittance_check_logs_list.length}件
                <button
                  type="button"
                  style={{ margin: "20px" }}
                  onClick={this.props.get_owner_remittance_check_logs}
                  className="btn btn-primary float-right"
                >検索</button>


                <CSVLink className="btn btn-success float-right" style={{ margin: "20px" }} data={this.props.owner_remittance_check_logs_list} >
                  CSV
</CSVLink>

                {/* <span className="float-right" style={{ margin: "20px" }}> {this.props.rent_contracts_check_list.length + "件"}</span> */}
              </td>

              {/* <td colSpan={1}>


                {this.props.search_form.search_completed === false ? <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.check_completed(true)}
                  className="btn btn-sm btn-danger float-right"
                >消込</button> : <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.check_completed_cancel(true)}
                  className="btn btn-sm btn-warning float-right"
                >取消</button>}
              </td> */}
            </tr >
          </tbody>
        </table>








      </div >
    );
  }
}




// const mapStateToProps = (state:any) => {
//     return {

//         responseid: state.customersReducer.responseid,
//         responsedetail: state.customersReducer.responsedetail,
//         customerNewDisp: state.customersReducer.customerNewDisp,
//         customerdetail0: state.customersReducer.customerdetail0

//     }
// }
// function mapDispatchToProps(dispatch:any) {
//     return {

//         // responseUpdate(state:any) {
//         //     dispatch(Responses.responseUpdate(state))
//         // },
//         // change_customerloding1(state:number) {
//         //     dispatch(Customers.change_customerloding1(state))
//         // },
//         // change_customerloding2(state:number) {
//         //     dispatch(Customers.change_customerloding2(state))
//         // },
//         // customerNewDispSet(state:number) {
//         //     dispatch(Customers.customerNewDispSet(state))
//         // },
//         // change_customeredit0(state:number) {
//         //     dispatch(Customers.change_customeredit0(state))
//         // },
//        get_rent_contract_accounting(state:any) {
//             dispatch(Monies.get_rent_contract_accounting(state))
//         },

//     };
// }
// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);

const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,

    so_ymd_list: state.RemittanceLogCheck.so_ymd_list,
    remittancelogcheck_search_form: state.RemittanceLogCheck.remittancelogcheck_search_form,

    so_ymd_list_sum: state.RemittanceLogCheck.so_ymd_list_sum,
    owner_remittance_check_logs_sum: state.RemittanceLogCheck.owner_remittance_check_logs_sum,
    owner_remittance_check_logs: state.RemittanceLogCheck.owner_remittance_check_logs,
    owner_remittance_check_logs_list: state.RemittanceLogCheck.owner_remittance_check_logs_list,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    get_owner_remittance_check_logs(state: any) {
      dispatch(RemittanceLogCheck.get_owner_remittance_check_logs(state))
    },
    change_remittancelogcheck_search_form(state: any) {
      dispatch(RemittanceLogCheck.change_remittancelogcheck_search_form(state))
    },

    change_search_diff(state: any) {
      dispatch(RemittanceLogCheck.change_search_diff(state))
    },

    // get_rent_contracts_check_list(state: any) {
    //   dispatch(RemittanceLogCheck.get_rent_contracts_check_list(state))
    // },
    // check_completed_cancel(state: any) {
    //   dispatch(RemittanceLogCheck.check_completed_cancel(state))
    // },

    // change_search_name(state: any) {
    //   dispatch(ContractSearch.change_search_name(state))
    // },
    // change_search_contract_date_start(state: any) {
    //   dispatch(ContractSearch.change_search_contract_date_start(state))
    // },
    // change_search_contract_date_end(state: any) {
    //   dispatch(ContractSearch.change_search_contract_date_end(state))
    // },
    // change_search_tatemono_name(state: any) {
    //   dispatch(ContractSearch.change_search_tatemono_name(state))
    // },
    //   get_banks(state:any) {
    //     dispatch(Kyousai.get_banks(state))
    // },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

